import Link from 'next/link'
import { Button } from '@components/UI/Button'

export default function About() {
  return (
    <div className="mb-12">
      <h4 className="mb-4 text-xl font-bold text-gray-600">About Majordomo</h4>
      <p className="my-4">Majordomo created the Domoreport.</p>
      <p className="my-4">
        The Domoreport is the most in-depth report on a home’s condition ever
        created, yet it’s easy to read and you can quickly figure out exactly
        what your buyers need to know. It’s the new standard for helping home
        buyers quickly understand the condition of their home with local and
        highly accurate repair estimates based on their inspection.
      </p>
      <p className="my-4 font-bold">The Second Half of the Home Inspection</p>

      <Link href="/checkout">
        <Button wide variant="primary" clipSide="right">
          Order Your Domoreport
        </Button>
      </Link>
    </div>
  )
}
